import DashboardSubMenuHeader from "../DashboardSubMenuHeader";
import { useLocation } from "react-router-dom";
import { Links } from "../Utility/Constants";
import PatientAnalytics from "./PatientAnalytics";

function Dashboard() {
  const location = useLocation();
  return (
    <>
      <DashboardSubMenuHeader></DashboardSubMenuHeader>
      {location.pathname === Links.schedulingAnalytics ||
      location.pathname === Links.root ? (
        <label class="p-5">Scheduling efficiency is under construction.</label>
      ) : location.pathname === Links.patientAnalytics ? (
        <PatientAnalytics></PatientAnalytics>
      ) : (
        <></>
      )}
    </>
  );
}
export default Dashboard;
